import apiClient from '../../../lib/axios';

export const fetchProjects = async ({
  page = 1,
  pageSize = 10,
  status,
  isActive,
  search,
} = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (status && status !== 'all') params.append('status', status);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);

  const { data } = await apiClient.get(
    `/api/projects?${params.toString()}`,
  );
  return data;
};

export const fetchActiveProjects = async () => {
  const { data } = await apiClient.get('/api/projects/active');
  return data;
};

export const fetchProjectById = async (id) => {
  const { data } = await apiClient.get(`/api/projects/${id}`);
  return data;
};

export const createProject = async (payload) => {
  const { data } = await apiClient.post('/api/projects', payload);
  return data;
};

export const updateProject = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/projects/${id}`, payload);
  return data;
};

export const deleteProject = async (id) => {
  const { data } = await apiClient.delete(`/api/projects/${id}`);
  return data;
};

export default fetchProjects;
